import { AnalyticsProvider } from 'use-analytics';
import { App } from './App';
import { createApiContextProvider } from '../api/ApiContext';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorManagerProvider } from './ErrorManager';
import { RecoilRoot } from 'recoil';
import { setTheme } from '../theme/setTheme';
import { TestingContextProvider } from '../testing/TestingContext';
import React, { useEffect } from 'react';

export const createAppProvider: (
  app: App<any, any>,
) => React.FC<React.PropsWithChildren> = (app) => {
  const ApiContextProvider = createApiContextProvider(app);

  return ({ children }) => {
    useEffect(() => {
      setTheme(app.theme);
    }, []);

    return (
      <RecoilRoot>
        <ErrorManagerProvider app={app}>
          <ErrorBoundary app={app}>
            <TestingContextProvider app={app}>
              <AnalyticsProvider instance={app.analyticsInstance}>
                <ApiContextProvider>{children}</ApiContextProvider>
              </AnalyticsProvider>
            </TestingContextProvider>
          </ErrorBoundary>
        </ErrorManagerProvider>
      </RecoilRoot>
    );
  };
};
